import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { EMRService } from 'app/EMR/EMR.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-history-other-info',
  templateUrl: './history-other-info.component.html',
  styleUrls: ['./history-other-info.component.scss']
})
export class HistoryOtherInfoComponent implements OnInit {
  enabledisablebtn:boolean =false;
  destroyother$: Subject<boolean> = new Subject<boolean>();
  isheader:boolean=false;
  constructor(private emrservice: EMRService, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
  private dialogRef: MatDialogRef<HistoryOtherInfoComponent>, private dashboardService:DashboardService,private dialog: MatDialog,) { }

  ngOnInit(): void {
    if(this.data){
      this.isheader = this.data.isheader;
     }else{
       this.isheader = false;
     }
    this.enabledisablebtn =true;
   // this.get_otherinfo();
  }
  closedialog(){
    this.dialogRef.close();
  }
  get_otherinfo() {
    this.emrservice.get_otherinfo().pipe(takeUntil(this.destroyother$)).subscribe(
      data => this.success_otherinfo(data), err => this.failed_otherinfo(err)
    )
  }

  success_otherinfo(data) {
    this.emrservice.otherinfo_history = data;
  }

  failed_otherinfo(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
    this.emrservice.otherinfo_history = {};
    // console.log("other info api failed");
  }

  save_otherinfo_toserver(name) {
 
    if(this.emrservice.otherhistoryPermission?.isAddPermission!=true && this.emrservice.otherinfo_history.pkTranId ==0){
      return this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
    if(this.emrservice.otherhistoryPermission?.isModifyPermission!=true && this.emrservice.otherinfo_history.pkTranId >0){
      return   this.dashboardService.openSnackBar("Modify permission denied", "OK");
    }
      this.emrservice.otherinfo_history.EntryHead = name;
      this.emrservice.save_other_info_history().pipe(takeUntil(this.destroyother$)).subscribe(
        data => this.success_history_otherinfo(data), err => this.failed_history_otherinfo(err)
      )
    
  }

  success_history_otherinfo(data) {
    this.enabledisablebtn =true;
    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
    this.get_otherinfo();
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
 
  }

  failed_history_otherinfo(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  letterOnly(event) {
    var charCode = event.keyCode;

    if (charCode == 78 || charCode == 89 || charCode == 110 || charCode == 121 )

      return true;
    else
      return false;
  }
  validateNo(e: any): boolean {
   
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }
  checkEnablebtn(event){
    this.enabledisablebtn =false;
  }
  showOptions(event:MatCheckboxChange): void {
    this.enabledisablebtn =false;
    this.emrservice.otherinfo_history.isBiohazard =event.checked;
    if(this.emrservice.otherinfo_history.isBiohazard ==false){
      this.emrservice.otherinfo_history.bioHazardDetail='';
    }
}
  refReasonPOpup(parameter,type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: parameter
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyother$)).subscribe(result => {
      if (result != 0) {
        this.enabledisablebtn =false;
        if(type ==1){
          this.emrservice.otherinfo_history.advReactionHistory=result;
        }else if(type ==2){
          this.emrservice.otherinfo_history.birthHistory=result;
        }else if(type ==3){
          this.emrservice.otherinfo_history.pastEyeHistory =result;
        }else if(type ==4){
          this.emrservice.otherinfo_history.specialremarks =result;
        }

      }
    });
  }
  ngOnDestroy() {
    this.destroyother$.next(true);
    this.destroyother$.unsubscribe();
    console.log("destory historyother info");
  } 
}
